import { useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import type { IsEmriDurumu, IsEmriOzet } from '@nero/shared';
import { ARACSIZ, para, plakaGoster, tarihGoster } from '@nero/shared';
import { useVeri } from '../lib/veri.js';
import { useOturum } from '../lib/oturum.js';
import { sorgu } from '../lib/api.js';
import { BosDurum, HataKutusu, Kart, SayfaBaslik, Yukleniyor } from '../bilesenler/temel.js';
import { Arama, SecenekSerit } from '../bilesenler/form.js';
import { Simge } from '../bilesenler/Simge.js';
import { DurumRozeti, OdemeRozeti } from './ortak/rozetler.js';
import { HizliIsEmri } from './ortak/HizliIsEmri.js';

type Sekme = 'acik' | 'tumu' | IsEmriDurumu;

const SEKMELER: Array<{ deger: Sekme; ad: string }> = [
  { deger: 'acik', ad: 'Açık' },
  { deger: 'Tamamlandi', ad: 'Tamamlanan' },
  { deger: 'Teslim', ad: 'Teslim' },
  { deger: 'tumu', ad: 'Tümü' },
];

export function IsEmirleri() {
  const [parametre, setParametre] = useSearchParams();
  const [sekme, setSekme] = useState<Sekme>('acik');
  const [arama, setArama] = useState('');
  const git = useNavigate();
  const { yetkili } = useOturum();
  const yeniAcik = parametre.get('yeni') === '1';

  const yol = useMemo(() => {
    if (sekme === 'acik') return `/is-emirleri${sorgu({ acik: '1', q: arama })}`;
    if (sekme === 'tumu') return `/is-emirleri${sorgu({ q: arama })}`;
    return `/is-emirleri${sorgu({ durum: sekme, q: arama })}`;
  }, [sekme, arama]);

  const { veri, yukleniyor, hata, yenile } = useVeri<IsEmriOzet[]>(yol);

  function pencereyiKapat() {
    parametre.delete('yeni');
    setParametre(parametre, { replace: true });
  }

  return (
    <div className="sayfa">
      <SayfaBaslik baslik="İş Emirleri" alt="Atölyeye giren her araç bir iş emriyle takip edilir">
        {yetkili('is_emri.olustur') && (
          <button className="btn btn-birincil" onClick={() => setParametre({ yeni: '1' })}>
            <Simge ad="arti" className="simge" /> Yeni iş emri
          </button>
        )}
      </SayfaBaslik>

      <div className="satir" style={{ marginBottom: 'var(--b4)', flexWrap: 'wrap', gap: 'var(--b3)' }}>
        <SecenekSerit deger={sekme} secenekler={SEKMELER} onChange={setSekme} />
        <Arama deger={arama} onChange={setArama} yerTutucu="Plaka, müşteri, iş emri no…" />
      </div>

      <Kart>
        {hata ? (
          <div className="kart-govde"><HataKutusu hata={hata} yenile={yenile} /></div>
        ) : yukleniyor ? (
          <div className="kart-govde"><Yukleniyor /></div>
        ) : !veri || veri.length === 0 ? (
          <BosDurum
            simge="is-emri"
            baslik={arama ? 'Sonuç bulunamadı' : 'Bu listede iş emri yok'}
            aciklama={arama ? 'Farklı bir plaka veya müşteri adı deneyin.' : 'Araç geldiğinde yeni iş emri açın.'}
          />
        ) : (
          <div className="tablo-sarma">
            <table className="tablo">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Araç</th>
                  <th>Müşteri</th>
                  <th>İşlem</th>
                  <th>Açılış</th>
                  <th>Durum</th>
                  <th className="sag">Tutar</th>
                  <th>Ödeme</th>
                </tr>
              </thead>
              <tbody>
                {veri.map((i) => (
                  <tr key={i.id} className="tiklanabilir" onClick={() => git(`/is-emirleri/${i.id}`)}>
                    <td className="ikincil sayi dar">{i.no}</td>
                    <td>
                      <div className="ana">{plakaGoster(i.plaka) || ARACSIZ}</div>
                      <div className="ikincil">{i.marka} {i.model}</div>
                    </td>
                    <td className="ikincil">{i.musteri_ad}</td>
                    <td className="ikincil">{i.islem || '—'}</td>
                    <td className="ikincil dar">{tarihGoster(i.acilis_at)}</td>
                    <td className="dar"><DurumRozeti durum={i.durum} /></td>
                    <td className="sag para">{para(i.tutar)}</td>
                    <td className="dar"><OdemeRozeti durum={i.odeme_durumu} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Kart>

      {yeniAcik && (
        <HizliIsEmri
          kapat={pencereyiKapat}
          olusturuldu={(id) => { pencereyiKapat(); git(`/is-emirleri/${id}`); }}
        />
      )}
    </div>
  );
}
